import React, { createContext, FC } from 'react';
import useTestPlan from './index';
import { TestPlanTypes } from './types';

// @ts-ignore
export const TestPlanContext = createContext<TestPlanTypes>({});

export const TestPlanProvider: FC = ({ children }) => {
  const value = useTestPlan();

  return (
    <TestPlanContext.Provider value={value}>
      {children}
    </TestPlanContext.Provider>
  );
};
